module.exports = __webpack_public_path__ + "img/Slice134.cf4e540c.png";